import React from 'react'

const Design = () => {
  return (
    <blockquote className="p-4 my-4 border-s-4 border-gray-300 bg-gray-50 w-full">
      <p className="text-xl italic font-medium leading-relaxed text-gray-900 w-full">
        "Flowbite is just awesome. It contains tons of predesigned components and pages starting
        from login screen to complex dashboard. Perfect choice for your next SaaS application."
      </p>
    </blockquote>
  )
}

export default Design
